import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import _ from 'lodash';
import shallowEqual from 'shallowequal';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { push, replace } from 'react-router-redux';
import { converter } from 'helpers/converter';
import { showModal, removeModal } from 'actions/response';
import { getHasNodeMusicEnabled } from 'containers/Header/selectors';
import Metrics from 'services/metrics';
import { loadSession, loadPlaylists } from '../../actions';
import { getHasConfigurated } from '../../selectors/config';
import { getHasTokenLoadedOnce } from '../../selectors/session';
import Playlists from '../Playlists';
import {
  getPlaylistsItems,
  getMuiscLoading,
  getMuiscError,
} from '../../selectors/playlists';
import getFirstNode from 'utils/getFirstNode';
import Loader from 'react-loader-spinner';
import styles from './newMusicPage.module.scss';

export const NewMusicPage = props => {
  const {
    isNodeMusicEnabled,
    isReadyToGenerateToken,
    isTokenCreated,
    loading,
    items,
    error,
    translations,
    //-------
    onLoadSession,
    onFetchPlaylists,
    showModal,
    closeModal,
    onPushHistroyState,
    onRedirectToHome,
  } = props;
  //consts
  const increaseItem = 20;
  const firstNode = getFirstNode();
  // states
  const [from, setFrom] = useState(increaseItem);
  const [itemsTotal, setItemsTotal] = useState([]);
  const [itemsRender, setItemsRender] = useState([]);
  // refs
  const oldIsNodeMusicEnabled = useRef(isNodeMusicEnabled);
  const oldIsReadyToGenerateToken = useRef(isReadyToGenerateToken);
  const oldIsTokenCreated = useRef(isTokenCreated);
  const oldError = useRef(error);
  const oldItems = useRef(items);
  const [gridHeigth, setGridHeigth] = useState(0)

  const elementScroll = useRef(null);
  const gridDivElement = document.querySelector('.row m-playlists')


  const handleNotAllowed = () => {
    const country = _.get(props, ['params', 'country']);
    _.invoke(props, 'onRedirectToHome', `/${country}/${firstNode}`);
  };

  const showErrorModal = () => {
    const message =
      converter.convertApaUnicode(translations, 'ErrorGeneric') ||
      'Ocurrió un error inesperado al consultar las playlists de Claro Música';
    const modal = {
      modalType: 'ErrorSimple',
      props: {
        message,
        onAccept: () => {
          closeErrorModal();
        },
        onClose: () => {
          closeErrorModal();
        },
      },
    };

    showModal(modal);
  };

  const closeErrorModal = () => {
    closeModal('ErrorSimple');
    const location = _.get(props, ['routeParams', 'country']);
    onPushHistroyState(`/${location}/${firstNode}`);
  };

  const handleGenerateToken = () => _.invoke(props, 'onLoadSession');

  const handleFetchPlaylists = () => _.invoke(props, 'onFetchPlaylists');

  const handleUpdate = () => {
    if (from >= itemsTotal.length) return;
    let addNewItems = from + increaseItem;
    if (addNewItems > itemsTotal.length) {
      addNewItems = itemsTotal.length;
    }
    const newItems = itemsTotal.slice(from, addNewItems);
    setFrom(from + increaseItem);
    setItemsRender([...itemsRender, ...newItems]);
  };

  const sendMetrics = () => {
    Metrics.newEvent({
      eventCategory: 'Top Menu',
      eventAction: 'Click',
      eventLabel: 'Claro Musica',
    });
  };


  // equivalente a componentDidMount
  useEffect(
    () => {
      if (!isNodeMusicEnabled) {
        handleNotAllowed();
      }

      if (!isReadyToGenerateToken) return;

      if (isTokenCreated) {
        sendMetrics();
        handleFetchPlaylists();
      } else {
        handleGenerateToken();
      }
    },
    [isNodeMusicEnabled, isReadyToGenerateToken, isTokenCreated],
  );

  // equivlenta a UNSAFE_componentWillReceiveProps
  useEffect(
    () => {
      const ownProps = {
        isNodeMusicEnabled: oldIsNodeMusicEnabled?.current,
        isReadyToGenerateToken: oldIsReadyToGenerateToken?.current,
        isTokenCreated: oldIsTokenCreated?.current,
        error: oldError?.current,
        items: oldItems?.current,
      };
      const newProps = {
        isNodeMusicEnabled,
        isReadyToGenerateToken,
        isTokenCreated,
        error,
        items,
      };

      if (
        !newProps.isNodeMusicEnabled &&
        !shallowEqual(newProps.isNodeMusicEnabled, ownProps.isNodeMusicEnabled)
      ) {
        if (!isNodeMusicEnabled) {
          handleNotAllowed();
        }
      }

      if (newProps.error && !shallowEqual(newProps.error, ownProps.error)) {
        handleGenerateToken();
        if (!isReadyToGenerateToken && isTokenCreated && !items.length) {
          handleFetchPlaylists();
        }
        showErrorModal();
      } else {
        if (
          newProps.isReadyToGenerateToken &&
          !shallowEqual(
            newProps.isReadyToGenerateToken,
            ownProps.isReadyToGenerateToken,
          )
        ) {
          handleGenerateToken();
        }

        if (
          newProps.isTokenCreated &&
          !shallowEqual(newProps.isTokenCreated, ownProps.isTokenCreated)
        ) {
          if (!isReadyToGenerateToken && isTokenCreated && !items.length) {
            sendMetrics();
            handleFetchPlaylists();
          }
        }

        if (newProps.items && !shallowEqual(newProps.items, ownProps.items)) {
          setItemsTotal(newProps?.items);
          setItemsRender(newProps.items.slice(0, increaseItem));
        }
      }
    },
    [
      //----
      isNodeMusicEnabled,
      isReadyToGenerateToken,
      isTokenCreated,
      loading,
      items,
      error,
      translations,
      onLoadSession,
      onFetchPlaylists,
      showModal,
      closeModal,
      onPushHistroyState,
      onRedirectToHome,
    ],
  );

  const onIntersection = elements => {
    if (elements[0].isIntersecting) {
      // solo se ejecuta si el elemento entra al viewPort
      setTimeout(() => {
        handleUpdate();
      }, 200);
    }
  };

  useEffect(
    () => {
      const observer = new IntersectionObserver(onIntersection, {
        root: null,
        rootMargin: '0px 0px 0px 0px',
        threshold: 0.5,
      });

      if (observer && elementScroll.current)
        observer.observe(elementScroll.current);

      return () => {
        if (observer) observer.disconnect();
      };
    },
    [elementScroll.current, itemsRender],
  );

  useEffect(()=>{
    if(itemsRender.length <= 0) return;
    const navContainerElement = document.querySelector('.nav__container');
    const footerDivElement = document
    .querySelector('.footer_web--footer')
    const visibleContentHeigth = (document.body.clientHeight - navContainerElement?.offsetHeight - footerDivElement?.offsetHeight)
    if(itemsRender.length <= 0) return;
    if(gridHeigth > (visibleContentHeigth) && footerDivElement.classList.contains('fixed-footer')){
      footerDivElement.classList.remove('fixed-footer');
    }


  },[itemsRender.length, gridHeigth])

    useEffect(() => {
      if (!document.querySelector('.container')) return;
  
      const observer = new ResizeObserver(([entry]) => {
        setGridHeigth(entry.contentRect.height)
      });
  
      observer.observe(document.querySelector('.container'));
  
      return () => observer.disconnect();
    }, []);
    
  return (
    <div className="container" data-testid="container-playlist">
      <Playlists loading={loading} error={error} items={itemsRender} />
      {!loading && 
        itemsRender.length > 0 &&
        itemsRender.length < itemsTotal.length && (
          <div ref={elementScroll} className={styles.containerLoader}>
            <Loader type="Oval" color="#8A0101" height={50} width={50} />
          </div>
        )}
    </div>
  );
};

const mapStateToProps = state => ({
  isNodeMusicEnabled: getHasNodeMusicEnabled(state),
  isReadyToGenerateToken: getHasConfigurated(state),
  isTokenCreated: getHasTokenLoadedOnce(state),
  loading: getMuiscLoading(state),
  items: getPlaylistsItems(state),
  error: getMuiscError(state),
  translations: state.translations,
  estado: state,
});

const mapDispatchToProps = dispatch => ({
  onLoadSession: () => dispatch(loadSession()),
  onFetchPlaylists: () => dispatch(loadPlaylists()),
  showModal: modal => dispatch(showModal(modal)),
  closeModal: modalType => dispatch(removeModal(modalType)),
  onPushHistroyState: payload => dispatch(push(payload)),
  onRedirectToHome: payload => dispatch(replace(payload)),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(withConnect)(NewMusicPage);
